import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-reusable-report-header',
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule, FormsModule],
  templateUrl: './reusable-report-header.html',
  styleUrls: ['./reusable-report-header.css'],
})
export class ReusableReportHeader {

  /** Report title displayed in the header, e.g. 'Sales By Customer' */
  @Input() reportTitle: string = '';

  /** Breadcrumb text, e.g. 'Reports > Sales > Sales By Customer' */
  @Input() breadcrumb: string = '';

  /** Custom icon path. Defaults to the reports icon. */
  @Input() icon: string = 'assets/images/icons/icon-reports-blue.png';

  /** Whether to show the PDF export button */
  @Input() showPdfButton: boolean = true;

  /** Whether the PDF button should be disabled */
  @Input() pdfDisabled: boolean = true;

  /** Whether to show the Excel export button */
  @Input() showExcelButton: boolean = false;

  /** Whether the Excel button should be disabled */
  @Input() excelDisabled: boolean = true;

  /** Whether to show the global search input */
  @Input() showGlobalSearch: boolean = true;

  /** Placeholder text for the search input */
  @Input() searchPlaceholder: string = 'Search';

  /** Whether to show the filter toggle button */
  @Input() showFilterToggle: boolean = true;

  /** Whether the filter panel is currently open */
  @Input() filterPanelOpen: boolean = false;

  /** Global search text (two-way binding via searchTextChange) */
  @Input() searchText: string = '';

  /** Count of global search matches */
  @Input() searchMatchCount: number = 0;

  /** Emits when user clicks PDF export */
  @Output() pdfExport = new EventEmitter<void>();

  /** Emits when user clicks Excel export */
  @Output() excelExport = new EventEmitter<void>();

  /** Emits when user types in the global search */
  @Output() searchTextChange = new EventEmitter<string>();

  /** Emits when user clears the global search */
  @Output() searchCleared = new EventEmitter<void>();

  /** Emits when user toggles the filter panel */
  @Output() filterToggle = new EventEmitter<void>();

  onSearchInput(value: string): void {
    this.searchText = value;
    this.searchTextChange.emit(value);
  }

  clearSearch(): void {
    this.searchText = '';
    this.searchTextChange.emit('');
    this.searchCleared.emit();
  }

  onPdfExport(): void {
    this.pdfExport.emit();
  }

  onExcelExport(): void {
    this.excelExport.emit();
  }

  onFilterToggle(): void {
    this.filterToggle.emit();
  }
}
